require('custom-event-polyfill');
require('element-closest');
require('es6-promise/auto');
